<form class="Sanofi-orderHistoryDatepicker row row-cols-sm-auto">
  <div class="col-12">
    <div>
      <div class="Sanofi-orderHistoryDatepicker__hidden position-absolute">
        <div class="input-group">
          <input
            name="datepicker"
            class="form-control"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="2"
            [dayTemplate]="t"
            outsideDays="hidden"
            [startDate]="fromDate()!"
            tabindex="-1"
          />
          <ng-template #t let-date let-focused="focused">
					<span
            class="Sanofi-orderHistoryDatepicker__customDay"
            [class.Sanofi-orderHistoryDatepicker__focused]="focused"
            [class.Sanofi-orderHistoryDatepicker__range]="isRange(date)"
            [class.Sanofi-orderHistoryDatepicker__faded]="isHovered(date) || isInside(date)"
            [class.Sanofi-orderHistoryDatepicker__firstInRange]="isFirstInRange(date)"
            [class.Sanofi-orderHistoryDatepicker__lastInRange]="isLastInRange(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
          >
						{{ date.day }}
					</span>
          </ng-template>
        </div>
      </div>
      <button [class.Sanofi-orderHistoryDatepicker__opened]="datepicker.isOpen()" (click)="datepicker.toggle()" type="button" class="Sanofi-orderHistoryDatepicker__bothDatesDisplayWrapper w-100 px-3 d-flex align-items-center">
        <fa-icon [icon]="faCalendar" class="Sanofi-orderHistoryDatepicker__calendarIcon px-1" />
        <div class="Sanofi-orderHistoryDatepicker__datesWrapper">
          @if (fromDate()) {
            <span>{{ formatter.format(fromDate()) | date: "MM/dd/yyyy" }}</span>
          } @else {
            <span>{{ 'ordersList.startDate' | cxTranslate }}</span>
          }
          <fa-icon [icon]="faArrowRight" class="Sanofi-orderHistoryDatepicker__arrowRightIcon px-1" />

          @if (toDate()) {
            <span>{{ formatter.format(toDate()) | date: "MM/dd/yyyy" }}</span>
          } @else {
            <span>{{ 'ordersList.endDate' | cxTranslate }}</span>
          }
        </div>
      </button>
    </div>
    <div class="input-group d-none">
      <input
        #dpFromDate
        class="form-control"
        placeholder="yyyy-mm-dd"
        name="dpFromDate"
        [value]="formatter.format(fromDate())"
        (input)="fromDate.set(validateInput(fromDate(), dpFromDate.value))"
      />
      <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datepicker.toggle()" type="button"></button>
    </div>
  </div>
  <div class="col-12">
    <div class="input-group d-none">
      <input
        #dpToDate
        class="form-control"
        placeholder="yyyy-mm-dd"
        name="dpToDate"
        [value]="formatter.format(toDate())"
        (input)="toDate.set(validateInput(toDate(), dpToDate.value))"
      />
      <button class="btn btn-outline-secondary bi bi-calendar3" (click)="datepicker.toggle()" type="button"></button>
    </div>
  </div>
</form>
